module.exports = __webpack_public_path__ + "img/address.bd59d87c.png";